import type { Quote } from '@orbis-systems/orbis-api-middleware';

export const DEFAULT_OPTION_CONTRACT_SIZE = 100;

export const getOptionContractSize = (quote?: Pick<Quote, 'contractSize'> | null): number =>
    quote?.contractSize || DEFAULT_OPTION_CONTRACT_SIZE;
